// 납입지시 - ERP_OEM 출하관리
import { Route, Switch } from 'react-router-dom';
import { lazy, Suspense } from 'react';


const ROM3Z = lazy(() => import('@/pages/A05/ROM3Z'));
const ROM3Y = lazy(() => import('@/pages/A05/ROM3Y'));
const ROM3W = lazy(() => import('@/pages/A05/ROM3W'));
const ROM90 = lazy(() => import('@/pages/A05/ROM90'));
const ROM91 = lazy(() => import('@/pages/A05/ROM91'));
const ROM92 = lazy(() => import('@/pages/A05/ROM92'));

function A05() {
  return ( 
    <Suspense fallback={null}>
      <Switch>
        <Route path="/A05/ROM3Z" component={ROM3Z} />
        <Route path="/A05/ROM3Y" component={ROM3Y} />
        <Route path="/A05/ROM3W" component={ROM3W} />
        <Route path="/A05/ROM90" component={ROM90} />
        <Route path="/A05/ROM91" component={ROM91} />
        <Route path="/A05/ROM92" component={ROM92} />
      </Switch>
    </Suspense>
  );
}

export default A05;
